export default "__VITE_ASSET__CJZPn$P5__"